import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { path: '/homepage', label: 'Home' },
    { path: '/platform-demo', label: 'Platform Demo' },
    { path: '/enterprise-solutions', label: 'Enterprise Solutions' },
    { path: '/api-documentation', label: 'API Docs' }
  ];

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <Link to="/homepage" className="header-logo">
            <img 
              src="/assets/images/PA-Large-Final-1769828585649.png" 
              alt="PolicyAlerts - Medical Policy Monitoring Platform" 
              className="h-8 w-auto"
            />
          </Link>

          <nav className="header-nav">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-nav-link ${isActive(item?.path) ? 'active' : ''}`}
              >
                {item?.label}
              </Link>
            ))}
          </nav>

          <div className="header-actions">
            <Button
              variant="outline"
              size="sm"
              iconName="Phone"
              iconPosition="left"
              className="hidden lg:flex"
            >
              Call Sales
            </Button>
            <Button
              variant="default"
              size="sm"
              asChild
            >
              <Link to="/request-demo">Request Demo</Link>
            </Button>
          </div>

          <button
            onClick={toggleMobileMenu}
            className="header-mobile-toggle"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </header>
      <div className={`header-mobile-menu ${isMobileMenuOpen ? 'open' : 'closed'}`}>
        <nav className="header-mobile-nav">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`header-mobile-nav-link ${isActive(item?.path) ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item?.label}
            </Link>
          ))}
          <div className="flex flex-col gap-3 mt-6">
            <Button
              variant="outline"
              iconName="Phone"
              iconPosition="left"
              fullWidth
            >
              Call Sales
            </Button>
            <Button
              variant="default"
              fullWidth
              asChild
            >
              <Link to="/request-demo">Request Demo</Link>
            </Button>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;